const buttonTokens = {
    sizes: {
      S: {
        width: "100px",
        height: "32px",
        fontSize: "14px",
        paddingX: "12px",
        gap: "8px"
      },
      M: {
        width: "130px",
        height: "40px",
        fontSize: "16px",
        paddingX: "16px",
        gap: "8px"
      },
      L: {
        width: "160px",
        height: "48px",
        fontSize: "16px",
        paddingX: "20px",
        gap: "8px"
      }
    },
    borderRadius: "24px"
  };
  
  export default buttonTokens;
  